/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = Margin
 *
 * 1 = Qualify
 */
export enum Vat {
  Margin = 0,
  Qualify = 1,
}
